import { CircularProgress, Button as MaterialButton } from '@mui/material';
import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import cm from '../../../utils/class-merge';

const ButtonPropTypes = {
  primary: PropTypes.bool,
  primaryDark: PropTypes.bool,
  primaryLight: PropTypes.bool,
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
  outlined: PropTypes.bool,
  small: PropTypes.bool,
  text: PropTypes.bool,
  outlinedColor: PropTypes.bool,
  icon: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
  fullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
};

const ButtonDefaultProps = {
  className: '',
};

const Button = forwardRef((props, ref) => {
  // init
  const { primary, primaryDark, primaryLight, disabled, icon, text, small, outlinedColor, danger, outlined, className, children, fullWidth = false, isLoading, ...rest } = props;

  // constants
  const classNames = cm(
    className,
    primary && 'btn-primary',
    danger && 'btn-danger',
    disabled && 'btn-disabled',
    outlined && 'btn-outlined',
    primaryDark && 'btn-primary-dark',
    primaryLight && 'btn-primary-light',
    outlinedColor && 'btn-outlined-color',
    small && 'btn-small',
    text && 'btn-text',
    icon && 'btn-icon',
    fullWidth && 'btn-w-full',
  );

  return (
    <MaterialButton ref={ref} disabled={disabled} className={classNames} {...rest}>
      {isLoading ? <CircularProgress size={22} style={{ color: outlined || outlinedColor ? '#2b60f6' : '#fff' }} /> : children}
    </MaterialButton>
  );
});

Button.propTypes = ButtonPropTypes;

Button.defaultProps = ButtonDefaultProps;

export default Button;
